export default {
  tr: {
    column: "Sütün",
    submit: "Gönder",
    close: "Kapat",
    columnData: "Veri sutünü",
    chooseColumn: "Sutün seçiniz",
    selected: "Seçildi",
    select: "Seç",
    selectColumn: "Sütün seçiniz",
    file: {
      select: "Dosya seçiniz",
      tryAgain: "Başka dosya seçiniz",
      withHeaders: "This file includes headers",
      withoutHeaders: "This file does not include headers"
    },
    error: {
      title: "Hata",
      columnNumber:
        "You do not have enough columns. <br><b>Required columns are</b>: ",
      missingColumns: "Missing required columns:",
      selectColumn: "You need to select all columns",
      fileNumber: "You need to select a file",
      fileSelection: "No file has been selected",
      invalidFile: "This file is invalid. Try to use a CSV or Xlsx file",
      noWorksheet: "Must have at least one worksheet",
      emptyWorksheet: "The worksheet is empty"
    }
  },
  en: {
    column: "Column",
    submit: "Submit",
    close: "OK",
    columnData: "Data for column",
    chooseColumn: "Choose a column",
    selected: "Selected",
    select: "Select",
    selectColumn: "Please choose a column",
    file: {
      select: "Lütfen bir excel dosyası seçiniz",
      tryAgain: "Choose another file",
      withHeaders: "This file includes headers",
      withoutHeaders: "This file does not include headers"
    },
    error: {
      title: "Error",
      columnNumber:
        "You do not have enough columns. <br><b>Required columns are</b>: ",
      missingColumns: "Missing required columns:",
      selectColumn: "You need to select all columns",
      fileNumber: "You need to select a file",
      fileSelection: "No file has been selected",
      invalidFile: "This file is invalid. Try to use a CSV or Xlsx file",
      noWorksheet: "Must have at least one worksheet",
      emptyWorksheet: "The worksheet is empty"
    }
  },
  fr: {
    column: "Colonne",
    submit: "Valider",
    close: "OK",
    columnData: "Données pour la colonne",
    chooseColumn: "Choisir une colonne",
    selected: "Selectionné",
    select: "Choisir",
    selectColumn: "Veuillez choisir une colonne",
    file: {
      select: "Veuillez selectionner un fichier",
      tryAgain: "Choisir un autre fichier",
      withHeaders: "Ce fichier possède des entêtes",
      withoutHeaders: "Ce fichier ne possède pas d'entêtes"
    },
    error: {
      title: "Erreur",
      columnNumber:
        "Vous n'avez pas assez de colonnes. <br><b>Vous devez avoir les colonnes suivantes</b>: ",
      missingColumns: "Les colonnes nécéssaires suivantes manquent:",
      selectColumn: "Vous devez remplir toutes les colonnes",
      fileNumber: "Vous devez choisir un fichier",
      fileSelection: "Aucun fichier n'a été selectionné",
      invalidFile:
        "Ce fichier est invalide. Veuillez essayer avec un fichier CSV ou Xlsx",
      noWorksheet: "Le fichier doit avoir au moins une feuille de calcul",
      emptyWorksheet: "Ce fichier est vide"
    }
  },
  nl: {
    column: "Kolom",
    submit: "Verzenden",
    close: "OK",
    columnData: "Data voor kolom",
    chooseColumn: "Kies een kolom",
    selected: "Geselecteerd",
    select: "Selecteer",
    selectColumn: "Kies een kolom",
    file: {
      select: "Selecteer een bestand",
      tryAgain: "Kies een ander bestand",
      withHeaders: "Dit bestand bevat headers",
      withoutHeaders: "Dit bestand bevat geen headers"
    },
    error: {
      title: "Fout",
      columnNumber:
        "Je hebt niet genoeg kolommen. <br><b>Benodigde kolommen zijn</b>: ",
      missingColumns: "Ontbrekende verplichte kolommen:",
      selectColumn: "Je moet alle kolommen selecteren",
      fileNumber: "Je moet een bestand kiezen",
      fileSelection: "Er is geen bestand gekozen",
      invalidFile: "Dit bestand is ongeldig. Gebruik en CSV of xlsx bestand",
      noWorksheet: "Ten minste één werkblad nodig",
      emptyWorksheet: "Het werkblad is leeg"
    }
  }
};
